import React, { useCallback } from 'react';
import { useLocation } from 'react-router';
import { useFlags } from 'launchdarkly-react-client-sdk';

import AddGroupModalWithCalendarIntegration from 'Shared/components/modals/AddGroupModalWithCalendarIntegration/AddGroupModalWithCalendarIntegration';
import SimpleAddGroupModal from 'Shared/components/modals/SimpleAddWorkspaceModals/SimpleAddGroupModal/SimpleAddGroupModal';

type Props = {
  onRedirectTo: Function;
};

function AddGroupModalHandler({ onRedirectTo }: Props) {
  const { search, pathname } = useLocation();
  const { simpleInviteModal: simpleInviteModalFlag } = useFlags();

  const isAddGroupModalOpen = useCallback(search.includes('add_group_open'), [search]);

  const handleAddGroupClose = useCallback(() => onRedirectTo(pathname), [onRedirectTo, pathname]);

  if (!isAddGroupModalOpen) return null;

  return simpleInviteModalFlag ? (
    <SimpleAddGroupModal onClose={handleAddGroupClose} />
  ) : (
    <AddGroupModalWithCalendarIntegration onClose={handleAddGroupClose} />
  );
}

export default AddGroupModalHandler;
